'use strict';

eventsController.$inject = [
	'$scope',
	'$rootScope',
	'$controller',
	'$location',
	'$q',
	'$uibModal',
	'$filter',
	'dialogHelper',
	'authService',
	'USER_CLAIMS',
	'eventService',
	'siteService',
	'utilsService',
	'reportHelper',
];
angular.module('schoolLinqApp').controller('eventsController', eventsController);

function eventsController(
	$scope,
	$rootScope,
	$controller,
	$location,
	$q,
	$uibModal,
	$filter,
	dialogHelper,
	authService,
	USER_CLAIMS,
	eventService,
	siteService,
	utilsService,
	reportHelper
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.busyPromise = $q.all([$scope.vm.loadEvents($scope.vm), $scope.vm.loadSites($scope.vm), $scope.vm.loadInvoiceStatus($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,

			loadingMessage: 'Loading ....',
			savingMessage: 'Saving ....',
			busyMessage: 'Loading ....',

			numberOfEvents: 0,
			events: [],
			sites: [],

			selectedEvent: null,
			backupEvent: null,

			filter: {
				tab: 'General',
			},

			eventPaging: {
				searchText: '',
				active: true,
				pageSize: 12,
				startIndex: 0,
				orderBy: 'EventCode',
				orderByDescending: false,
			},

			receipts: {
				statuses: ['All', 'Deposited', 'Undeposited'],
				filter: {
					barLimit: 8,
					startIndex: 0,
					status: 'All',
					propertyName: 'ReceiptId',
					reverse: false,
				},
			},

			invoices: {
				statuses: [],
				filter: {
					barLimit: 8,
					startIndex: 0,
					statusId: 0,
					propertyName: 'InvoiceNumber',
					reverse: false,
				},
			},

			pageControl: {},
			currentSelectedStatus: true,
			currentSearchText: '',

			validationErrors: [],
			errors: null,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'Events', 'manageEvents'),
		};

		function formIsDirty() {
			return $scope.generalForm.$dirty;
		}

		function changeTab(model, tab) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.filter.tab = tab;
			}
		}

		function sortby(model, propertyName) {
			model.eventPaging.orderByDescending = model.eventPaging.orderBy === propertyName ? !model.eventPaging.orderByDescending : false;
			model.eventPaging.orderBy = propertyName;
			model.busyMessage = model.loadingMessage;
			$scope.busyPromise = model.loadEvents();
		}

		function changePage(model) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, backFunction, acceptFunction);

			function acceptFunction() {
				model.currentSelectedStatus = model.eventPaging.active;
				model.currentSearchText = model.eventPaging.searchText;
				model.eventPaging.StartIndex = model.pageControl.startIndex;
				model.busyMessage = model.loadingMessage;
				$scope.busyPromise = model.loadEvents();
			}

			function backFunction() {
				// cleanup/reset
				model.eventPaging.active = model.currentSelectedStatus;
				model.eventPaging.searchText = model.currentSearchText;
				if (model.pageControl.previousPageIndex !== model.pageControl.currentPageIndex)
					model.pageControl.setPageIndexBack(model.pageControl.previousPageIndex);
				return angular.noop;
			}
		}

		function getPageIndexForEvent(model, event) {
			model.eventPaging.eventId = event.Id;

			return eventService.getPageIndexForEvent(model.eventPaging).then(_.partial(finishGetPageIndex, model));

			function finishGetPageIndex(model, response) {
				return response.data;
			}
		}

		function loadEvents(model) {
			return eventService.getEvents(model.eventPaging).then(_.partial(finishLoadingEvents, model));

			function finishLoadingEvents(model, response) {
				model.numberOfEvents = response.data.totalNumberOfEvents;
				model.events = response.data.events;
				if (model.selectedEvent !== null) {
					let found = _.find(model.events, function (obj) {
						return obj.Id === model.selectedEvent.Id;
					});
					if (found === undefined) model.selectedEvent = null;
				}
				return angular.noop;
			}
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				if (response.data.isValid) {
					model.sites = response.data.sites;
				} else {
					model.errors = response.data.errors;
				}
				return angular.noop;
			}
		}

		function loadInvoiceStatus(model) {
			return utilsService.getInvoiceStatus().then(_.partial(finishLoadingInvoiceStatus, model));

			function finishLoadingInvoiceStatus(model, response) {
				model.invoices.statuses = _.filter(response.data, function (item) {
					return item.Id !== 4; /* Deleted */
				});
				model.invoices.statuses.unshift({ Id: 0, Description: 'All' });

				return angular.noop;
			}
		}

		function selectEvent(model, id) {
			dialogHelper.dirtyDialog(model.formIsDirty, model.cancelSave, null, acceptFunction);

			function acceptFunction() {
				model.busyMessage = model.loadingMessage;
				$scope.busyPromise = eventService
					.getEvent(id)
					.then(_.partial(finishLoadingEvent, model))
					.then(function () {
						return angular.noop;
					});
			}

			function finishLoadingEvent(model, response) {
				if (response.data.isValid === false) {
					model.errors = response.data.errors;
					return angular.noop;
				}
				model.errors = null;
				model.validationErrors = [];
				model.selectedEvent = response.data.event;
				model.selectedEvent.StartDate = moment(model.selectedEvent.StartDate).toDate();
				model.selectedEvent.EndDate = moment(model.selectedEvent.EndDate).toDate();

				model.backupEvent = angular.copy(model.selectedEvent);

				return angular.noop;
			}
		}

		function addEvent(model) {
			dialogHelper.dirtyDialog(model.formIsDirty, resetForm, null, acceptFunction);

			function acceptFunction() {
				model.showAddEvent(model);
			}

			function resetForm() {
				model.selectedEvent = null;
				$scope.generalForm.$setPristine();
			}
		}

		function showAddEvent(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/events/event-add-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'eventService',
						function ($scope, modalInstance, eventService) {
							$scope.newEvent = {};
							$scope.newEvent.Active = true;
							$scope.newEvent.StartDate = moment().toDate();

							// if there is only one site available then go ahead and select it for the user.
							if (model.sites.length === 1) {
								$scope.newEvent.SiteId = model.sites[0].Id;
							}

							angular.extend($scope, {
								cancel: function () {
									model.errors = null;
									model.validationErrors = [];
									modalInstance.close();
								},
								save: function () {
									model.errors = null;
									model.validationErrors = [];
									if ($scope.newEvent.StartDate > $scope.newEvent.EndDate) {
										model.validationErrors.push('Start Date cannot be after the End Date.');
										return false;
									}
									if (!$scope.addEventForm.$valid) return false;

									$scope.savingPromise = eventService.addEvent($scope.newEvent).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(response.data.eventId);
										} else {
											model.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (eventId) {
					if (eventId) {
						model.eventPaging.active = true;
						model.busyMessage = model.loadingMessage;
						$scope.busyPromise = loadEvents($scope.vm)
							.then(function () {
								return model.getPageIndexForEvent({ Id: eventId });
							})
							.then(function (pageIndex) {
								model.pageControl.setPageIndex(pageIndex);
								return model.selectEvent(eventId);
							});
					}
				});
		}

		function deleteEvent(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/events/event-delete-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						'eventService',
						function ($scope, modalInstance, eventService) {
							angular.extend($scope, {
								cancel: function () {
									model.errors = null;
									model.validationErrors = [];
									modalInstance.close(false);
								},
								deleteEvent: function () {
									model.errors = null;
									model.validationErrors = [];

									$scope.deletingPromise = eventService.deleteEvent($scope.vm.selectedEvent.Id).then(function (response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											model.errors = response.data.errors;
										}
									});
								},
							});
						},
					],
				})
				.result.then(function (success) {
					if (success) {
						model.busyMessage = model.loadingMessage;
						$scope.busyPromise = $scope.vm.loadEvents().then(function () {
							$scope.vm.selectedEvent = null;
						});
					}
				});
		}

		function validateForm(model) {
			var isValid = true;

			if (model.selectedEvent.StartDate > model.selectedEvent.EndDate) {
				model.validationErrors.push('Start Date cannot be after the End Date.');
				isValid = false;
			}

			return isValid;
		}

		function save(model) {
			model.validationErrors = [];

			$scope.generalForm.$setSubmitted();

			if (!model.validateForm()) {
				return;
			}

			if (model.isReadOnly || (!$scope.generalForm.$valid && model.filter.tab === 'General')) return false;

			model.busyMessage = model.savingMessage;
			$scope.busyPromise = eventService.updateEvent(model.selectedEvent).then(_.partial(finishSaving, model));

			function finishSaving(model, response) {
				if (response.data.isValid) {
					$scope.generalForm.$setPristine();
					model.backupEvent = angular.copy(model.selectedEvent);

					model.busyMessage = model.loadingMessage;
					$scope.busyPromise = loadEvents($scope.vm).then(function () {
						if (model.selectedEvent) return selectEvent($scope.vm, model.selectedEvent.Id);
						else return;
					});
				} else {
					model.errors = response.data.errors;
				}
			}
		}

		function cancelSave(model) {
			model.errors = null;
			model.validationErrors = [];
			$scope.generalForm.$setPristine();
			model.selectedEvent = angular.copy(model.backupEvent);
		}

		function filterReceiptList(model, receipt) {
			if (model.receipts.filter.status === 'Deposited') {
				return receipt.Deposited;
			}
			if (model.receipts.filter.status === 'Undeposited') {
				return !receipt.Deposited;
			}

			return true;
		}

		function filterInvoiceList(model, invoice) {
			if (model.invoices.filter.statusId === 0) {
				return true;
			}

			return model.invoices.filter.statusId === invoice.StatusId;
		}

		function getReceiptLinesTotal(model) {
			return _.reduce(
				model.filteredReceiptLineList,
				function (memo, item) {
					if (item.VoidDT) {
						return 0;
					}
					return memo + item.TotalAmount;
				},
				0
			);
		}

		function getInvoiceLinesTotal(model) {
			return _.reduce(
				model.filteredInvoiceLineList,
				function (memo, item) {
					if (item.VoidActualDT) {
						return 0;
					}
					return memo + item.Amount;
				},
				0
			);
		}

		function sortReceiptsBy(model, propertyName) {
			model.receipts.filter.reverse = model.receipts.filter.propertyName === propertyName ? !model.receipts.filter.reverse : false;
			model.receipts.filter.propertyName = propertyName;
		}

		function sortInvoicesBy(model, propertyName) {
			model.invoices.filter.reverse = model.invoices.filter.propertyName === propertyName ? !model.invoices.filter.reverse : false;
			model.invoices.filter.propertyName = propertyName;
		}

		function viewReceipt(model, receiptId) {
			var url = '/api/receipts/' + receiptId + '/pdf';
			reportHelper.getReport($scope, url, null, 'Receipt.pdf');
		}

		function displayInvoice(model, invoiceId) {
			model.errors = '';

			var payableInvoiceScope = $scope.$new();
			$controller('payableInvoicesController', { $scope: payableInvoiceScope });

			// set a watch on a state variable so we can know when the user is done view/editing
			// then we can update the list so it will reflect any changes made
			// *this is only needed if/when we allow the user to edit from here
			//payableInvoiceScope.$watch("vm.newEditState", function (state) {
			//    if (state == 'Done') {
			//        model.searchInvoices();
			//    }
			//}, true);

			payableInvoiceScope.vm.newEditInvoice(invoiceId, false, true);
		}

		return angular.extend(model, {
			formIsDirty: formIsDirty,
			changeTab: _.partial(changeTab, model),
			sortby: _.partial(sortby, model),
			changePage: _.partial(changePage, model),
			getPageIndexForEvent: _.partial(getPageIndexForEvent, model),
			loadEvents: _.partial(loadEvents, model),
			loadSites: _.partial(loadSites, model),
			loadInvoiceStatus: _.partial(loadInvoiceStatus, model),
			selectEvent: _.partial(selectEvent, model),
			addEvent: _.partial(addEvent, model),
			showAddEvent: _.partial(showAddEvent, model),
			deleteEvent: _.partial(deleteEvent, model),
			validateForm: _.partial(validateForm, model),
			save: _.partial(save, model),
			cancelSave: _.partial(cancelSave, model),
			filterReceiptList: _.partial(filterReceiptList, model),
			filterInvoiceList: _.partial(filterInvoiceList, model),
			getReceiptLinesTotal: _.partial(getReceiptLinesTotal, model),
			getInvoiceLinesTotal: _.partial(getInvoiceLinesTotal, model),
			sortReceiptsBy: _.partial(sortReceiptsBy, model),
			sortInvoicesBy: _.partial(sortInvoicesBy, model),
			viewReceipt: _.partial(viewReceipt, model),
			displayInvoice: _.partial(displayInvoice, model),
		});
	}

	var onRouteChangeOff = $scope.$on('$locationChangeStart', _.partial(dialogHelper.routeChange, $scope.vm.formIsDirty, acceptRouteChangeFunction));

	function acceptRouteChangeFunction() {
		onRouteChangeOff(); // Stop listening for location changes
		return angular.noop;
	}
}
